export const OnlinePaymentInformationPageTemplate = {
    slots: ['SlbNewPaymentContainerSlot'],
};